import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import './App.css';
import { HeaderBar, SiteFooter } from 'organisms';
import { BRANDS, ROUTES, brandForPath } from 'constants/index';
import {
  useBrandCanvas,
  useNavigationMenu,
  useScrollToTop,
  useScrolled,
} from 'hooks';

/** Distance past the hero before the header slides in on the home page. */
const HEADER_REVEAL_OFFSET = 80;

const App: React.FC = () => {
  const { pathname } = useLocation();

  const brand = brandForPath(pathname);
  const isHome = pathname === ROUTES.home;

  const scrolled = useScrolled(HEADER_REVEAL_OFFSET);
  const menu = useNavigationMenu(pathname);
  useScrollToTop(pathname);
  useBrandCanvas(brand);

  // On the home page the header only appears once you scroll past the hero.
  const headerVisible = scrolled || !isHome;

  return (
    <div className="app-root" data-brand={brand}>
      <div className={`app-shift ${menu.isOpen ? 'app-shift--open' : ''}`}>
        <HeaderBar
          logoSrc={BRANDS[brand].headerLogo}
          wordmark={BRANDS[brand].headerWordmark}
          wordmarkUppercase={BRANDS[brand].headerWordmarkUppercase}
          wordmarkSize={BRANDS[brand].headerWordmarkSize}
          logoHeight={BRANDS[brand].headerLogoHeight}
          label={BRANDS[brand].name}
          onOpenMenu={menu.toggle}
          isMenuOpen={menu.isOpen}
          className={`app-header ${headerVisible ? 'app-header--visible' : ''}`}
        />

        <main className="app-main">
          <Outlet />
        </main>

        <SiteFooter />
      </div>

      <button
        type="button"
        className={`menu-overlay ${menu.isOpen ? 'menu-overlay--visible' : ''}`}
        onClick={menu.close}
        aria-label="Close menu"
        tabIndex={menu.isOpen ? 0 : -1}
      />

      <aside
        className={`menu-panel ${menu.isOpen ? 'menu-panel--open' : ''}`}
        aria-label="Navigation menu"
        inert={!menu.isOpen}
      >
        <nav className="menu-panel-nav">
          <Link className="menu-panel-link" to={ROUTES.home}>
            Home
          </Link>
          <Link className="menu-panel-link" to={ROUTES.aquarist}>
            Aquarist
          </Link>
          <Link className="menu-panel-link" to={ROUTES.idleCafe}>
            Idle Café
          </Link>
        </nav>
      </aside>
    </div>
  );
};

export default App;
